/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPoll,
    JsonPollFromJSON,
    JsonPollFromJSONTyped,
    JsonPollToJSON,
} from './JsonPoll';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonPoll
 */
export interface ApiResultOfListOfJsonPoll {
    /**
     * 
     * @type {Array<JsonPoll>}
     * @memberof ApiResultOfListOfJsonPoll
     */
    data?: Array<JsonPoll>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPoll
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonPoll
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPoll
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPoll
     */
    result?: ApiResultOfListOfJsonPollResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonPollResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonPollFromJSON(json: any): ApiResultOfListOfJsonPoll {
    return ApiResultOfListOfJsonPollFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonPollFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonPoll {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonPollFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonPollToJSON(value?: ApiResultOfListOfJsonPoll | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonPollToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

